import { gql } from '@apollo/client';

import {
  AddFormMessagesPreviewDocument,
  type AddFormMessagesPreviewMutation,
  type AddFormMessagesPreviewMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddFormMessagesPreview($input: AddFormMessagesPreviewInput!) {
      addFormMessagesPreview(input: $input) {
        messages {
          id
          text
          createdAt
          sender
          transcript
          contentUrl
          assets {
            id
            name
            url
            description
            createdAt
            updatedAt
          }
        }
        surveyProgress
      }
    }
  `;
}

export const ADD_FORM_MESSAGES_PREVIEW = AddFormMessagesPreviewDocument;
export type {
  AddFormMessagesPreviewMutation,
  AddFormMessagesPreviewMutationVariables,
};
